// import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import React, { FC } from 'react';
import { Select, Option } from 'carbon-react/lib/components/select';

import { TotalRow } from '../types';
import { MARGIN_LEFT_LEVEL } from './header-row-utils';
import { usePredictionsInfoContext } from '../../../context/predictions-info-context';
import { PredictionsSubCategories } from '../../../../../core/types';

import grid from '../../../../../ui/data-grid/components/grid.scss';

interface Props {
  totalRow: TotalRow;
  level: number;
  wrapperStyle: React.CSSProperties;
  categoryOptions?: { name: string; value: PredictionsSubCategories }[];
}

export const HeaderRowHeadlineTotal: FC<Props> = ({
  level,
  wrapperStyle,
  totalRow: {
    isMainHeadline,
    isBold,
    subtitle,
    supertitle,
    name,
    account: { name: accountName }
  },
  categoryOptions
}: Props) => {
  const { setCategory, category } = usePredictionsInfoContext();

  const headerRowClasses = classNames({
    [grid.rowHeader]: true,
    [grid.isMainHeadline]: Boolean(isMainHeadline)
  });

  const headerRowInnerClasses = classNames({
    [grid.rowHeaderInner]: true
  });

  const handleCategoryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCategory && setCategory(event.target.value);
  };

  const showCategoryDropdown = (categoryOptions || []).length > 1;

  return (
    <div style={wrapperStyle} className={headerRowClasses} data-testid="header-row-headline-total">
      <div className={headerRowInnerClasses} style={{ marginLeft: level * MARGIN_LEFT_LEVEL }}>
        <div className={classNames(grid.rowHeaderTitleWrapper)}>
          {supertitle && <div className={grid.supertitle}>{supertitle}</div>}
          {showCategoryDropdown ? (
            <div className={grid.carbonSelectCategory}>
              <Select
                autoComplete="off"
                value={category ?? ''}
                onChange={handleCategoryChange}
                size="small"
                transparent
                listWidth={200}
              >
                {categoryOptions?.map(option => (
                  <Option key={option.value} value={option.value} text={option.name} />
                ))}
              </Select>
            </div>
          ) : (
            <div className={classNames(grid.title, { [grid.isBold]: isBold })} data-testid="account-name">
              {name || accountName}
            </div>
          )}
          {subtitle && (
            <div className={classNames(grid.title, grid.subtitle, { [grid.isBold]: isBold })}>{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
};
